import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useProductUpdate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, body }) => {
      const config = body instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
      const res = await api.put(`/product/update/${id}`, body, config);
      return res.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["viewProduct"] });
      if (variables?.id) {
        queryClient.invalidateQueries({ queryKey: ["product", variables.id] });
      }
    },
  });
};